<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
                <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />月度申报
            </el-col>
            <el-col :xs="24" :md="18">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()"
                    style="text-align: right;">
                    <el-form-item>
                        <el-button class="uploadBtn" type="primary" @click="openDown('https://lhyg1.oss-cn-beijing.aliyuncs.com/template/%E4%BA%92%E8%81%94%E7%BD%91%E5%B9%B3%E5%8F%B0%E4%BC%81%E4%B8%9A%E4%BB%A3%E5%8A%9E%E7%94%B3%E6%8A%A5%E8%A1%A8.xls')">导出(互联网平台企业代办申报表)</el-button>
                        <el-button class="uploadBtn" type="primary" @click="openDown('https://lhyg1.oss-cn-beijing.aliyuncs.com/template/%E5%8A%B3%E5%8A%A1%E6%8A%A5%E9%85%AC%E6%89%80%E5%BE%97-%E8%AE%B2%E8%A7%A3%EF%BC%88%E9%80%82%E7%94%A8%E7%B4%AF%E8%AE%A1%E9%A2%84%E6%89%A3%E6%B3%95%EF%BC%89.xls')">导出(个人所得税申报表)</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button class="exportBtn" type="default" @click="downloadHandle">批量导出</el-button>
                    </el-form-item> -->
                </el-form>
            </el-col>
        </el-row>

        <div class="mod-declare__personnel">
            <el-row style="border-bottom: 3px solid #F3F4F4;padding-bottom: 10px;">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">

                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报时间">
                        <el-date-picker v-model="createTimeRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            @change="createTimeChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报数据编号">
                        <el-input v-model="dataForm.applyDataNo" placeholder="申报数据编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报状态">
                        <el-select v-model="dataForm.declareStatus" placeholder="请选择" clearable>
                            <el-option label="待申报" value="0"></el-option>
                            <el-option label="申报中" value="1"></el-option>
                            <el-option label="申报成功未缴款" value="2"></el-option>
                            <el-option label="申报成功无需缴款" value="3"></el-option>
                            <el-option label="作废中" value="4"></el-option>
                            <el-option label="已缴款" value="5"></el-option>
                            <el-option label="缴款中" value="6"></el-option>
                            <el-option label="申报失败" value="7"></el-option>
                            <el-option label="作废" value="8"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报月份">
                        <el-date-picker
                            v-model="dataForm.createTimeRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="createTimeChange">
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="灵活用工平台名称">
                        <el-select v-model="dataForm.bodyId" placeholder="请选择" clearable>
                            <el-option v-for="item in bodyPageList" :key="item.id"
                                :label="`${item.bodyName}-${item.abbreviation}`" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报方式">
                        <el-select v-model="dataForm.declareType" placeholder="请选择" clearable>
                            <el-option label="线上报送" value="0"></el-option>
                            <el-option label="线下报送" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item style="margin-top: 20px;margin-left: 20px;" label="申报月份">
                        <el-date-picker v-model="yearTimeRange" type="monthrange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM"
                            @change="timeYearChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-top: 20px;margin-left: 20px;">
                        <el-button type="primary" @click="getDataList()">查询</el-button>
                        <el-button type="default" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <div class="table-container">
                <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle"
                    @sort-change="dataListSortChangeHandle" style="width: 100%;" height="100%">
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <!-- <el-table-column prop="dataNo" label="数据编号" header-align="center" align="center"
                        width="180"></el-table-column> -->
                    <el-table-column prop="createDate" label="申报时间" header-align="center" align="center"
                        width="100">
                        <template slot-scope="scope">
                            {{ scope.row.createDate ? timeFormat(scope.row.createDate) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="applyDataNo" label="申报数据编号" header-align="center" align="center"
                        width="180"></el-table-column>
                    <el-table-column prop="platformCompany" label="灵活用工平台名称" header-align="center" align="center"
                        width="150"></el-table-column>
                    <el-table-column prop="declareMonth" label="申报月份" header-align="center" align="center"
                        width="100"></el-table-column>
                        <el-table-column prop="declareCount" label="申报人数" header-align="center" align="center"
                        width="100"></el-table-column>
                    <el-table-column prop="declareType" label="申报方式" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.declareType === 0" size="small" type="primary">线上申报</el-tag>
                            <el-tag v-else-if="scope.row.declareType === 1" size="small" type="warning">线下申报</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="userUniqueCode" label="用户唯一标识码" header-align="center" align="center"
                        width="150"></el-table-column> -->
                    <!-- <el-table-column prop="declareMonth" label="申报月份" header-align="center" align="center"
                        width="120"></el-table-column>
                    <el-table-column prop="personStatus" label="人员状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.personStatus === 0" size="small" type="success">正常</el-tag>
                            <el-tag v-else-if="scope.row.personStatus === 1" size="small" type="danger">异常</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="declareStatus" label="申报状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.declareStatus === 0" size="small" type="info">待申报</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 1" size="small" type="warning">申报中</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 2" size="small" type="success">申报成功未缴款</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 3" size="small" type="danger">申报成功无需缴款</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 4" size="small" type="danger">作废中</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 5" size="small" type="danger">已缴款</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 6" size="small" type="danger">缴款中</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 7" size="small" type="danger">申报失败</el-tag>
                            <el-tag v-else-if="scope.row.declareStatus === 8" size="small" type="danger">作废</el-tag>
                            <el-tag v-else size="small">--</el-tag>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="declareDesc" label="申报说明" header-align="center" align="center"
                        width="200"></el-table-column> -->
                    <el-table-column prop="incomeTotal" label="申报收入总计(含税)" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.incomeTotal ? moneyUtils(scope.row.incomeTotal) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxAmount" label="税金金额（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.taxAmount ? moneyUtils(scope.row.taxAmount) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomeTax" label="个税（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.incomeTax ? moneyUtils(scope.row.incomeTax) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="valueAddedTax" label="增值税（元）" header-align="center" align="center"
                        width="120">
                        <template slot-scope="scope">
                            {{ scope.row.valueAddedTax ? moneyUtils(scope.row.valueAddedTax) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="surcharge" label="附加税（元）" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.surcharge ? moneyUtils(scope.row.surcharge) : '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" header-align="center" align="center"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="withholdingReturnPath" label="个人所得税扣缴申报表(附件)" header-align="center" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.withholdingReturnPath" type="primary" size="small" @click="downloadFile(scope.row.withholdingReturnPath)">下载</el-button>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxPaymentVoucherPath" label="个人所得税完税凭证(附件)" header-align="center" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.taxPaymentVoucherPath" type="primary" size="small" @click="downloadFile(scope.row.taxPaymentVoucherPath)">下载</el-button>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="agencyReturnPath" label="互联网平台企业代办申报表(附件)" header-align="center" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.agencyReturnPath" type="primary" size="small" @click="downloadFile(scope.row.agencyReturnPath)">下载</el-button>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="vatPaymentVoucherPath" label="增值税及附加税完税凭证(附件)" header-align="center" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.vatPaymentVoucherPath" type="primary" size="small" @click="downloadFile(scope.row.vatPaymentVoucherPath)">下载</el-button>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" header-align="center" align="center" width="120"
                        fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="editHandle(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit"
                :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>

        <el-dialog title="选择税源地" :visible.sync="submitDialogVisible" width="600px"
            :before-close="handleCloseSubmitDialog">
            <div class="upload-dialog-content">
                <el-form>
                    <el-form-item label="税源地名称:">
                        <el-select v-model="bodyId" placeholder="请选择税源地" :clearable="false" style="width: 60%;">
                            <el-option v-for="item in bodyPageList" :key="item.id"
                                :label="`${item.bodyName}-${item.abbreviation}`" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseSubmitDialog">取 消</el-button>
                <el-button type="primary" @click="confirmSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑申报结果" :visible.sync="editDialogVisible" width="700px" :before-close="handleCloseEditDialog">
            <div class="edit-dialog-content">
                <div class="dialog-tip">您正在对线补用报的结果进行线上结果反馈，请填写开上传相关信息</div>
                <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="190px">
                    <el-form-item label="灵活用工平台名称:">
                        <span>{{ editForm.platformCompany }}</span>
                    </el-form-item>
                    <el-form-item label="申报月份:">
                        <span>{{ editForm.declareMonth }}</span>
                    </el-form-item>
                    <el-form-item label="申报人数:">
                        <span>{{ editForm.declareCount }}</span>
                    </el-form-item>
                    <el-form-item label="申报收入总计（元）:">
                        <span>{{ editForm.incomeTotal }}</span>
                    </el-form-item>
                    <el-form-item label="个税（元）:">
                        <span>{{ editForm.incomeTax }}</span>
                    </el-form-item>
                    <el-form-item label="增值税（元）:">
                        <span>{{ editForm.valueAddedTax }}</span>
                    </el-form-item>
                    <el-form-item label="附加税（元）:">
                        <span>{{ editForm.surcharge }}</span>
                    </el-form-item>
                    <el-form-item label="申报状态:" prop="declareStatus">
                        <el-select v-model="editForm.declareStatus" placeholder="请选择申报状态" clearable
                            style="width: 100%;">
                            <el-option label="待申报" :value="0"></el-option>
                            <el-option label="申报中" :value="1"></el-option>
                            <el-option label="申报成功未缴款" :value="2"></el-option>
                            <el-option label="申报成功无需缴款" :value="3"></el-option>
                            <el-option label="作废中" :value="4"></el-option>
                            <el-option label="已缴款" :value="5"></el-option>
                            <el-option label="缴款中" :value="6"></el-option>
                            <el-option label="申报失败" :value="7"></el-option>
                            <el-option label="作废" :value="8"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item label="个人所得税扣缴申报表:">
                        <el-upload ref="withholdingReturnUpload"
                            :action="url"
                            accept=".pdf,.jpg,.jpeg,.png"
                            :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'withholdingReturnFile')"
                            :on-remove="(file, fileList) => handleUploadRemove(file, fileList, 'withholdingReturnFile')"
                            :multiple="false"
                            :file-list="editForm.withholdingReturnFileList"
                            :limit="1">
                            <el-button slot="trigger" size="small" type="default">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="个人所得税完税凭证:">
                        <el-upload ref="taxPaymentVoucherUpload"
                            :action="url"
                            accept=".pdf,.jpg,.jpeg,.png"
                            :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'taxPaymentVoucherFile')"
                            :on-remove="(file, fileList) => handleUploadRemove(file, fileList, 'taxPaymentVoucherFile')"
                            :multiple="false"
                            :file-list="editForm.taxPaymentVoucherFileList"
                            :limit="1">
                            <el-button slot="trigger" size="small" type="default">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="互联网平台企业代办电报表:">
                        <el-upload ref="agencyReturnUpload"
                            :action="url"
                            accept=".pdf,.jpg,.jpeg,.png"
                            :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'agencyReturnFile')"
                            :on-remove="(file, fileList) => handleUploadRemove(file, fileList, 'agencyReturnFile')"
                            :multiple="false"
                            :file-list="editForm.agencyReturnFileList"
                            :limit="1">
                            <el-button slot="trigger" size="small" type="default">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="增值税及附加税完税凭证:">
                        <el-upload ref="vatPaymentVoucherUpload"
                            :action="url"
                            accept=".pdf,.jpg,.jpeg,.png"
                            :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'vatPaymentVoucherFile')"
                            :on-remove="(file, fileList) => handleUploadRemove(file, fileList, 'vatPaymentVoucherFile')"
                            :multiple="false"
                            :file-list="editForm.vatPaymentVoucherFileList"
                            :limit="1">
                            <el-button slot="trigger" size="small" type="default">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="备注:">
                        <el-input type="textarea" :rows="3" placeholder="请输入备注信息" v-model="editForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseEditDialog">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import DataUtils from '@/utils/DataUtils'
import DateUtils from '@/utils/DateUtils'
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
    mixins: [mixinViewModule],
    data() {
        return {
            url:`${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
            submitDialogVisible: false,
            editDialogVisible: false,
            fileList: [],
            bodyId: '',
            editForm: {
                id: '',
                platformCompany: '',
                // declareMonth: '',
                declareCount: '',
                incomeTotal: '',
                incomeTax: '',
                valueAddedTax: '',
                surcharge: '',
                declareStatus: '',
                withholdingReturnFile: null,
                taxPaymentVoucherFile: null,
                agencyReturnFile: null,
                vatPaymentVoucherFile: null,
                withholdingReturnName: '',
                withholdingReturnPath: '',
                taxPaymentVoucherName: '',
                taxPaymentVoucherPath: '',
                agencyReturnName: '',
                agencyReturnPath: '',
                vatPaymentVoucherName: '',
                vatPaymentVoucherPath: '',
                withholdingReturnFileList: [],
                taxPaymentVoucherFileList: [],
                agencyReturnFileList: [],
                vatPaymentVoucherFileList: [],
                remark: ''
            },
            editFormRules: {
                declareStatus: [
                    { required: true, message: '请选择申报状态', trigger: 'change' }
                ]
            },
            mixinViewModuleOptions: {
                isBodyPage: true,
                createdIsNeed: true,
                getDataListURL: '/sys/plat/tax/monthly/declare/page',
                getDataListIsPage: true,
                exportURL: '/declare/personnel/export'
            },
            createTimeRange: [],
            yearTimeRange: [],
            dataForm: {
                // declareMonth: DateUtils.format(new Date(), 'yyyy-MM'),
                createStartTime: '',
                createEndTime: '',
                applyDataNo: '',
                declareStatus: '',
                bodyId: '',
                declareType: '',
                startMonth: '',
                endMonth: ''
            }
        }
    },
    methods: {
        timeFormat(time) {
            return DateUtils.format(new Date(time), 'yyyy-MM-dd')
        },
        openDown(path){
            window.open(path,'_blank')
        },
        downloadFile(path){
            window.open(path,'_blank')
        },
        createTimeChange(val) {
            if (val && val.length === 2) {
                this.dataForm.createStartTime = val[0]
                this.dataForm.createEndTime = val[1]
            } else {
                this.dataForm.createStartTime = ''
                this.dataForm.createEndTime = ''
            }
        },
        timeYearChange(val) {
            if (val && val.length === 2) {
                this.dataForm.startMonth = val[0]
                this.dataForm.endMonth = val[1]
            } else {
                this.dataForm.startMonth = ''
                this.dataForm.endMonth = ''
            }
        },
        moneyUtils(data) {
            return DataUtils.moneyUtils(data)
        },
        resetForm() {
            this.dataForm = {
                // declareMonth: DateUtils.format(new Date(), 'yyyy-MM'),
                createStartTime: '',
                createEndTime: '',
                applyDataNo: '',
                declareStatus: '',
                bodyId: '',
                declareType: '',
                startMonth: '',
                endMonth: ''
            }
            this.createTimeRange = []
            this.yearTimeRange = []
            this.getDataList()
        },
        submitSbsj() {
            this.submitDialogVisible = true
            this.fileList = []
        },
        handleCloseSubmitDialog() {
            this.submitDialogVisible = false
            this.fileList = []
        },
        // downloadTemplate() {
        //     const token = Cookies.get('access_token')
        //     window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/person/submit/template?access_token=${token}`)
        // },
        confirmSubmit() {
            if (!this.bodyId) {
                return this.$message.warning('请选择税源地')
            }
            this.$http.post('/sys/plat/tax/person/submit/update-submit-status', {
                bodyId: this.bodyId,
                // declareMonth: this.dataForm.declareMonth
            }).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.$message.success('提交成功')
                this.submitDialogVisible = false
                this.getDataList()
            }).catch(() => {
                this.$message.error('提交失败')
            })
        },
        // downloadHandle() {
        //     const params = qs.stringify({
        //         'access_token': Cookies.get('access_token'),
        //         ...this.dataForm
        //     })
        //     window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/tax/person/submit/export?${params}`)
        // },
        editHandle(row) {
            // 将行数据复制到编辑表单，并把附件名/路径回显到 el-upload 的 file-list
            this.editForm = {
                ...row,
                // 保持已有的上传字段为 null，只有用户选择新文件时才会上传
                withholdingReturnFile: null,
                taxPaymentVoucherFile: null,
                agencyReturnFile: null,
                vatPaymentVoucherFile: null,
                // 附件名称/路径（回显来源于 row）
                withholdingReturnName: row.withholdingReturnName || '',
                withholdingReturnPath: row.withholdingReturnPath || '',
                taxPaymentVoucherName: row.taxPaymentVoucherName || '',
                taxPaymentVoucherPath: row.taxPaymentVoucherPath || '',
                agencyReturnName: row.agencyReturnName || '',
                agencyReturnPath: row.agencyReturnPath || '',
                vatPaymentVoucherName: row.vatPaymentVoucherName || '',
                vatPaymentVoucherPath: row.vatPaymentVoucherPath || '',
                // 如果后端返回了 name/path，则构造 fileList 供 el-upload 回显
                withholdingReturnFileList: (row.withholdingReturnName || row.withholdingReturnPath) ? [{ name: row.withholdingReturnName || '附件', url: row.withholdingReturnPath }] : [],
                taxPaymentVoucherFileList: (row.taxPaymentVoucherName || row.taxPaymentVoucherPath) ? [{ name: row.taxPaymentVoucherName || '附件', url: row.taxPaymentVoucherPath }] : [],
                agencyReturnFileList: (row.agencyReturnName || row.agencyReturnPath) ? [{ name: row.agencyReturnName || '附件', url: row.agencyReturnPath }] : [],
                vatPaymentVoucherFileList: (row.vatPaymentVoucherName || row.vatPaymentVoucherPath) ? [{ name: row.vatPaymentVoucherName || '附件', url: row.vatPaymentVoucherPath }] : [],
                remark: row.remark || ''
            }
            this.editDialogVisible = true
        },
        handleCloseEditDialog() {
            this.editDialogVisible = false
            this.$refs.editForm.resetFields()
            this.editForm = {
                id: '',
                platformCompany: '',
                // declareMonth: '',
                declareCount: '',
                incomeTotal: '',
                incomeTax: '',
                valueAddedTax: '',
                surcharge: '',
                declareStatus: null,
                withholdingReturnFile: null,
                taxPaymentVoucherFile: null,
                agencyReturnFile: null,
                vatPaymentVoucherFile: null,
                withholdingReturnName: '',
                withholdingReturnPath: '',
                taxPaymentVoucherName: '',
                taxPaymentVoucherPath: '',
                agencyReturnName: '',
                agencyReturnPath: '',
                vatPaymentVoucherName: '',
                vatPaymentVoucherPath: '',
                withholdingReturnFileList: [],
                taxPaymentVoucherFileList: [],
                agencyReturnFileList: [],
                vatPaymentVoucherFileList: [],
                remark: ''
            }
        },
        handleFileChange(file, fileList, fileType) {
            // 不再保存文件流，仅回显文件名/列表，提交时通过 upload2 接口传递 name/path 字段
            this.editForm[fileType + 'List'] = fileList.slice(-1)
            // 尝试设置 name 字段为本地文件名，path 保持为空（或使用已有 url）
            const last = fileList.slice(-1)[0]
            if (last) {
                this.editForm[fileType.replace(/File$/, 'Name')] = last.name || ''
                // 如果存在 url（回显已有附件），使用它作为 path
                this.editForm[fileType.replace(/File$/, 'Path')] = last.url || this.editForm[fileType.replace(/File$/, 'Path')] || ''
            }
        },
        handleUploadSuccess(res, file, fileList, fileType) {
            if (!res || res.code !== 0) {
                return this.$message.error((res && res.msg) || '上传失败')
            }
            // el-upload 的 response 通常在 file.response 中，也把 fileList 更新为后端返回的命名
            for (let i = 0; i < fileList.length; i++) {
                const resp = fileList[i].response || res
                if (resp && resp.data) {
                    const d = resp.data
                    fileList[i].name = d.fileName ? (d.fileName + (d.fileType ? '.' + d.fileType : '')) : fileList[i].name
                    // 设置 url 到 response.data.url 或 data.url
                    fileList[i].url = d.url || d.fileUrl || d.filePath || fileList[i].url
                }
            }
            this.editForm[fileType + 'List'] = fileList
            // 更新对应的 name/path 字段
            const base = fileType.replace(/File$/, '')
            const respData = (file && file.response && file.response.data) ? file.response.data : (res && res.data) ? res.data : {}
            this.editForm[base + 'Name'] = respData.fileName ? (respData.fileName + (respData.fileType ? '.' + respData.fileType : '')) : (this.editForm[base + 'Name'] || '')
            this.editForm[base + 'Path'] = respData.url || respData.fileUrl || respData.filePath || this.editForm[base + 'Path'] || ''
        },
        handleUploadRemove(file, fileList, fileType) {
            this.editForm[fileType + 'List'] = fileList
            const base = fileType.replace(/File$/, '')
            if (!fileList || fileList.length === 0) {
                this.editForm[base + 'Name'] = ''
                this.editForm[base + 'Path'] = ''
                return
            }
            const remaining = fileList[fileList.length - 1]
            this.editForm[base + 'Name'] = remaining.name || ''
            const remainingResponse = remaining.response || {}
            const remainingData = remainingResponse.data || {}
            this.editForm[base + 'Path'] = remaining.url || remainingData.url || remainingData.fileUrl || remainingData.filePath || ''
        },
        confirmEdit() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                const formData = new FormData()
                formData.append('id', this.editForm.id)
                formData.append('declareStatus', this.editForm.declareStatus)
                formData.append('withholdingReturnName', this.editForm.withholdingReturnName || '')
                formData.append('withholdingReturnPath', this.editForm.withholdingReturnPath || '')
                formData.append('taxPaymentVoucherName', this.editForm.taxPaymentVoucherName || '')
                formData.append('taxPaymentVoucherPath', this.editForm.taxPaymentVoucherPath || '')
                formData.append('agencyReturnName', this.editForm.agencyReturnName || '')
                formData.append('agencyReturnPath', this.editForm.agencyReturnPath || '')
                formData.append('vatPaymentVoucherName', this.editForm.vatPaymentVoucherName || '')
                formData.append('vatPaymentVoucherPath', this.editForm.vatPaymentVoucherPath || '')
                formData.append('remark', this.editForm.remark || '')
                this.$http.post('/sys/plat/tax/monthly/declare/editeStatus', formData)
                    .then(({ data: res }) => {
                        if (res && res.code !== 0) {
                            return this.$message.error(res.msg || '编辑失败')
                        }
                        this.$message.success('编辑成功')
                        this.handleCloseEditDialog()
                        this.getDataList()
                    }).catch(() => {
                        this.$message.error('编辑失败')
                    })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.mod-declare__personnel {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 190px);

    .el-row {
        flex-shrink: 0;
    }

    .table-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-top: 20px;

        .el-table {
            flex: 1;
            overflow: hidden;
        }
    }

    .el-pagination {
        flex-shrink: 0;
        margin-top: 20px;
        text-align: right;
    }
}

/deep/ .el-table {
    .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #f5f7fa;
    }

    .el-table__fixed-header-wrapper {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #f5f7fa;
    }
}
</style>
